import { moduleFactory } from "@/factories/module";
import { _generateIntegerHashForString } from "@/modules/string/generateIntegerHash";
import { toOxfordComma } from "@/modules/string/to-oxford-comma";

export const stringModule = moduleFactory.create({
  generateIntegerHash: _generateIntegerHashForString,
  toOxfordComma: toOxfordComma,
});
